import { render } from "./showProcedure.vue?vue&type=template&id=7dd08046"
import script from "./showProcedure.vue?vue&type=script&lang=js"
export * from "./showProcedure.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__